export default __webpack_public_path__ + "static/media/gruzian.4a47ab26.png";